import React from 'react';
import { Badge } from '@razorpay/blade/components';
import { MissingBankAccount } from 'api/types/missingInformationReportTypes';

export const getStatusBadge = (verificationStatus: MissingBankAccount['verification_status']) => {
  switch (verificationStatus) {
    case 'failed':
      return (
        <Badge color="negative" emphasis="subtle">
          Verification Failed
        </Badge>
      );
    case 'invalid':
      return (
        <Badge color="notice" emphasis="subtle">
          Invalid
        </Badge>
      );
    case 'created':
    case null:
      return (
        <Badge color="notice" emphasis="subtle">
          Unverified
        </Badge>
      );
    case 'mismatch':
      return (
        <Badge color="notice" emphasis="subtle">
          Name Mismatch
        </Badge>
      );
    case 'verified':
      return (
        <Badge color="positive" emphasis="subtle">
          Verified
        </Badge>
      );
    default:
      return null;
  }
};
